import {ExtraItem} from "./interfaces";

export const designTray: ExtraItem = {
  id: "XKD",
  name: "kabelgoot design (grijs of zwart) per 5m",
  price: 75
};

export const aluminiumTray: ExtraItem = {
  id: "XKA",
  name: "kabelgoot design (Aluminium) per 5m",
  price: 175
};

export const aerialPlatform15: ExtraItem = {
  id: "XHK15",
  name: "Knikarm <15,77m hoogtewerker huren, inclusief transport, exclusief parkeerverbod",
  price: 395
};

export const highFacadeExtraCost: ExtraItem = {
  id: "XPH",
  name: "Plaatsen buitenunit op hoogte >2,5m (excl hoogtewerker)",
  price: 100
};

export const roofExtraCost: ExtraItem = {
  id: "EC-R", // Is er hier iets beter voor in Teamleader?
  name: "extra kost dak",
  price: 50
};

export const LGArtcoolZwartInsideUnit: ExtraItem = {
  id: "XLG-Artcool zwart",
  name: "LG Artcool zwart wandmodel (enkel geldig met een LG multi set)",
  price: 250
};

export const LGDeluxeInsideUnit: ExtraItem = {
  id: "XLG-Deluxe",
  name: "LG Deluxe wandmodel (enkel geldig met een LG multi set)",
  price: 175
};

export const DaikinEmuraGrijsInsideUnit: ExtraItem = {
  id: "XD-Emura grijs",
  name: "Daikin Emura grijs wandmodel (enkel geldig bij een Daikin multi set)",
  price: 325
};

export const DaikinEmuraWitInsideUnit: ExtraItem = {
  id: "XD-Emura wit",
  name: "Daikin Emura wit wandmodel (enkel geldig bij een Daikin multi set)",
  price: 195
};

export const DaikinStylishGrijsInsideUnit: ExtraItem = {
  id: "XD-Stylish grijs",
  name: "Daikin Stylish grijs wandmodel (enkel geldig bij een Daikin multi set)",
  price: 325
};

export const DaikinStylishWitInsideUnit: ExtraItem = {
  id: "XD-Stylish wit",
  name: "Daikin Stylish wit wandmodel (enkel geldig bij een Daikin multi set)",
  price: 195
};

export const DaikinStylishZwartInsideUnit: ExtraItem = {
  id: "XD-Stylish zwart",
  name: "Daikin Stylish zwart wandmodel (enkel geldig bij een Daikin multi set)",
  price: 325
};

export const DaikinStylishZwartHoutInsideUnit: ExtraItem = {
  id: "XD-Stylish zwart/hout",
  name: "Daikin Stylish zwart/hout wandmodel (enkel geldig bij een Daikin multi set)",
  price: 325
};